import Tool from '../../common/tool';
import WmRequest from '../../common/request';
import Config from '../../common/config';
import SearchResultAppPicker from './searchResultAppPicker';
import HelpSearchSuggest from '../help/helpSearchSuggest';
import { renderProductList } from '../procenter/renderProductCard';
import { initProcenterDownloadButtons } from '../procenter/procenterDownload';
import { renderSearchManualList } from './renderSearchManualCard';
import { renderSearchArticleList } from './renderSearchArticleCard';
var SearchResultMain = /** @class */ (function () {
    function SearchResultMain() {
        var _this = this;
        this.pageIndex = 1;
        this.searchBoxDom = document.getElementById('search');
        this.resultDom = document.getElementById('result');
        this.searchURL = '';
        this.searchURLObj = {};
        this.wmRequest = new WmRequest();
        this.appPicker = new SearchResultAppPicker(function (gId) {
            window.location.href = _this.buildSearchUrl({ g_id: gId, page: 1 });
        });
        this.init();
    }
    SearchResultMain.prototype.init = function () {
        this.initPageIndex();
        this.syncPageLayout();
        this.appPicker.syncFromUrl(this.isApplicationTab() ? '' : (this.searchURLObj.g_id || ''));
        this.handleSearch();
        this.toggleTab();
    };
    /** 软件应用 Tab：不展示筛选应用，URL 也不带 g_id */
    SearchResultMain.prototype.isApplicationTab = function (tab) {
        var _a;
        var t = ((_a = tab !== null && tab !== void 0 ? tab : this.searchURLObj.tab) !== null && _a !== void 0 ? _a : '').toLowerCase();
        return t === 'application' || t === 'software';
    };
    SearchResultMain.prototype.syncPageLayout = function () {
        document.body.classList.toggle('is-tab-application', this.isApplicationTab());
    };
    SearchResultMain.prototype.getHeadDom = function () {
        return document.querySelector('.daetool-search-result-head');
    };
    /** 拼接搜索结果页地址，统一保留 keywords / tab / page / g_id */
    SearchResultMain.prototype.buildSearchUrl = function (overrides) {
        var _a, _b, _c, _d, _e, _f;
        var keywords = (_b = (_a = overrides === null || overrides === void 0 ? void 0 : overrides.keywords) !== null && _a !== void 0 ? _a : this.searchURLObj.keywords) !== null && _b !== void 0 ? _b : '';
        var tab = (_d = (_c = overrides === null || overrides === void 0 ? void 0 : overrides.tab) !== null && _c !== void 0 ? _c : this.searchURLObj.tab) !== null && _d !== void 0 ? _d : 'article';
        var page = (_f = (_e = overrides === null || overrides === void 0 ? void 0 : overrides.page) !== null && _e !== void 0 ? _e : this.pageIndex) !== null && _f !== void 0 ? _f : 1;
        var gId = (overrides === null || overrides === void 0 ? void 0 : overrides.g_id) !== undefined ? overrides.g_id : (this.searchURLObj.g_id || '');
        if (this.isApplicationTab(tab)) {
            gId = '';
        }
        var params = new URLSearchParams({
            keywords: keywords,
            tab: tab,
            page: String(page),
        });
        if (gId) {
            params.set('g_id', gId);
        }
        return "/searchResult?".concat(params.toString());
    };
    SearchResultMain.prototype.initPageIndex = function () {
        var _this = this;
        var params = new URLSearchParams(window.location.search);
        this.searchURLObj = {};
        params.forEach(function (val, key) {
            _this.searchURLObj[key] = val;
        });
        this.searchURL = window.location.search.substring(1);
        this.pageIndex = Number(this.searchURLObj.page) || 1;
    };
    SearchResultMain.prototype.handleSearch = function () {
        var that = this;
        var inputDom = Tool.$_select(this.searchBoxDom, '.search-input');
        var searchBtn = Tool.$_select(this.searchBoxDom, '.search-btn');
        var goSearch = function (keyword) {
            var value = (keyword !== null && keyword !== void 0 ? keyword : inputDom.value).trim();
            if (!value) {
                alert('关键词不能为空！');
                return;
            }
            that.pageIndex = 1;
            var tab = that.searchURLObj.tab || 'article';
            window.location.href = that.buildSearchUrl({ keywords: value, tab: tab, page: 1 });
        };
        var searchSuggest = new HelpSearchSuggest(this.searchBoxDom, goSearch);
        searchBtn.addEventListener('click', function () { return goSearch(); });
        inputDom.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                if (!searchSuggest.handleEnter()) {
                    goSearch();
                }
            }
        });
    };
    SearchResultMain.prototype.toggleTab = function () {
        var that = this;
        // 保存当前tab
        localStorage.setItem('current-tab', this.searchURLObj.tab);
        // 点击tab
        var headDom = this.getHeadDom();
        var tabItems = Tool.$_selectAll(headDom, '.tabs-box .tab-item');
        tabItems.forEach(function (item) {
            item.addEventListener('click', function () {
                var newTab = item.getAttribute('data-tab');
                var currentTab = that.searchURLObj.tab || localStorage.getItem('current-tab');
                var page = currentTab !== newTab ? 1 : that.pageIndex;
                localStorage.setItem('current-tab', newTab);
                window.location.href = that.buildSearchUrl({
                    tab: newTab,
                    page: page,
                    g_id: that.isApplicationTab(newTab) ? null : undefined,
                });
            });
        });
        // 按 URL tab 激活并拉数（用 data-tab，避免 classify_alias 与 URL 不一致时 .tab-item.course 选不到）
        this.activateInitialTab(tabItems);
    };
    /** 根据 URL 的 tab 触发首屏请求；DOM 无对应 tab 时仍按 URL 调接口（后端 course/article 已映射） */
    SearchResultMain.prototype.activateInitialTab = function (tabItems) {
        var _a;
        var tab = this.searchURLObj.tab;
        var initSelectTab = Tool.$_select(this.getHeadDom(), ".tabs-box .tab-item[data-tab=\"".concat(tab, "\"]"));
        if (initSelectTab) {
            tabItems.forEach(function (tItem) { return tItem.classList.remove('active'); });
            initSelectTab.classList.add('active');
            this.getData(tab);
            return;
        }
        tabItems.forEach(function (tItem) { return tItem.classList.remove('active'); });
        var firstTab = tabItems[0];
        firstTab === null || firstTab === void 0 ? void 0 : firstTab.classList.add('active');
        this.getData(tab || ((_a = firstTab === null || firstTab === void 0 ? void 0 : firstTab.getAttribute('data-tab')) !== null && _a !== void 0 ? _a : 'article'));
    };
    SearchResultMain.prototype.getData = function (tabType) {
        var that = this;
        // 清空
        var wrapper = Tool.$_select(this.resultDom, '.result-wrapper');
        wrapper.innerHTML = '';
        // loading显示
        var loadingIcon = Tool.$_select(this.resultDom, '.loading-box');
        loadingIcon.classList.add('active');
        // 请求数据
        var requestData = {
            keywords: this.searchURLObj.keywords,
            tab: tabType,
            page: this.pageIndex,
        };
        if (this.searchURLObj.g_id && !this.isApplicationTab(tabType)) {
            requestData.g_id = this.searchURLObj.g_id;
        }
        this.wmRequest.ajax({
            url: Config.WM_GETSEARCHRESULT,
            type: 'POST',
            data: requestData,
        }).then(function (res) {
            loadingIcon.classList.remove('active');
            if (res.code == 200) {
                var data = res.data.data;
                var empty = Tool.$_select(that.resultDom, '.empty-box');
                if (data.length == 0) {
                    empty.classList.add('show');
                    that.clearPagination();
                }
                else {
                    empty.classList.remove('show');
                    that.handleAppend({
                        tabType: tabType,
                        data: data,
                        wrapper: wrapper,
                    });
                    wm_not_page_script_main();
                    var baseData = res.data;
                    that.pageIndex = baseData.current_page;
                    that.initPagination(baseData.current_page, baseData.per_page, baseData.total);
                }
            }
            else {
                console.log('error');
            }
        }).catch(function (err) {
            console.log(err);
        });
    };
    /** 与产品中心一致：DaetoolPagination + 翻页整页跳转 */
    SearchResultMain.prototype.clearPagination = function () {
        var el = document.querySelector('#pagination');
        if (el) {
            el.innerHTML = '';
        }
    };
    SearchResultMain.prototype.initPagination = function (currentPage, pageSize, total) {
        if (typeof DaetoolPagination === 'undefined') {
            console.warn('[searchResult] daetoolPagination.js 未加载');
            return;
        }
        var that = this;
        this.clearPagination();
        try {
            new DaetoolPagination({
                element: '#pagination',
                type: 2,
                layout: 'home, prev, pager, next, jumper, last',
                pageIndex: currentPage,
                pageSize: pageSize,
                pageCount: 5,
                total: total,
                singlePageHide: true,
                ellipsis: true,
                disabled: true,
                currentChange: function (index) {
                    window.location.href = that.buildSearchUrl({
                        tab: that.searchURLObj.tab,
                        page: index,
                    });
                },
            });
        }
        catch (e) {
            console.log(e);
        }
    };
    // 插入数据
    SearchResultMain.prototype.handleAppend = function (obj) {
        var wrapper = obj.wrapper, tabType = obj.tabType;
        var unitDom = this.handleUnit(obj);
        wrapper.insertAdjacentHTML('beforeend', unitDom);
        // 插入数据后，给软件应用绑定事件
        if (tabType === 'software'
            || tabType === 'application'
            || tabType === 'manual'
            || tabType === 'operate') {
            if (tabType === 'software' || tabType === 'application') {
                this.bindProductCardEvents(wrapper);
            }
            initProcenterDownloadButtons(wrapper);
            this.createAppQrcode();
        }
    };
    // 组装dom单元
    SearchResultMain.prototype.handleUnit = function (obj) {
        var tabType = obj.tabType, data = obj.data;
        var appendStr = '';
        // 搜索词高亮
        var keywords = this.searchURLObj.keywords;
        switch (tabType) {
            case 'manual':
            case 'operate': {
                var items = data.map(function (row) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                    return ({
                        title: String((_a = row.title) !== null && _a !== void 0 ? _a : ''),
                        details: String((_b = row.details) !== null && _b !== void 0 ? _b : ''),
                        details_url: String((_c = row.details_url) !== null && _c !== void 0 ? _c : ''),
                        create_time: String((_d = row.create_time) !== null && _d !== void 0 ? _d : ''),
                        g_id: row.g_id,
                        i_url: String((_e = row.i_url) !== null && _e !== void 0 ? _e : ''),
                        win32_url: String((_f = row.win32_url) !== null && _f !== void 0 ? _f : ''),
                        win64_url: String((_g = row.win64_url) !== null && _g !== void 0 ? _g : ''),
                        macM1_url: String((_h = row.macM1_url) !== null && _h !== void 0 ? _h : ''),
                        macIntel_url: String((_j = row.macIntel_url) !== null && _j !== void 0 ? _j : ''),
                        android_url: String((_k = row.android_url) !== null && _k !== void 0 ? _k : ''),
                        ios_url: String((_l = row.ios_url) !== null && _l !== void 0 ? _l : ''),
                    });
                });
                appendStr = renderSearchManualList(items, keywords);
                break;
            }
            case 'article':
            case 'question':
            case 'course':
            case 'faq':
            case 'information': {
                var items = data.map(function (row) {
                    var _a, _b, _c, _d, _e;
                    return ({
                        article_id: row.article_id,
                        classify_alias: String((_a = row.classify_alias) !== null && _a !== void 0 ? _a : ''),
                        title: String((_b = row.title) !== null && _b !== void 0 ? _b : ''),
                        details: String((_c = row.details) !== null && _c !== void 0 ? _c : ''),
                        page_img: String((_d = row.page_img) !== null && _d !== void 0 ? _d : ''),
                        key_word: row.key_word,
                        create_time: String((_e = row.create_time) !== null && _e !== void 0 ? _e : ''),
                    });
                });
                appendStr = renderSearchArticleList(items, keywords);
                break;
            }
            case 'application':
            case 'software': {
                var items = data.map(function (row) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                    return ({
                        g_id: row.g_id,
                        g_name: String((_a = row.g_name) !== null && _a !== void 0 ? _a : ''),
                        g_website: String((_b = row.g_website) !== null && _b !== void 0 ? _b : ''),
                        logo_url: String((_d = (_c = row.logo_url) !== null && _c !== void 0 ? _c : row.i_url) !== null && _d !== void 0 ? _d : ''),
                        details_url: String((_e = row.details_url) !== null && _e !== void 0 ? _e : ''),
                        win32_url: String((_f = row.win32_url) !== null && _f !== void 0 ? _f : ''),
                        win64_url: String((_g = row.win64_url) !== null && _g !== void 0 ? _g : ''),
                        macM1_url: String((_h = row.macM1_url) !== null && _h !== void 0 ? _h : ''),
                        macIntel_url: String((_j = row.macIntel_url) !== null && _j !== void 0 ? _j : ''),
                        android_url: String((_k = row.android_url) !== null && _k !== void 0 ? _k : ''),
                        ios_url: String((_l = row.ios_url) !== null && _l !== void 0 ? _l : ''),
                    });
                });
                appendStr = "<div class=\"daetool-search-result-product-cards\"><div class=\"daetool-procenter-list__grid\">".concat(renderProductList(items, keywords), "</div></div>");
                break;
            }
        }
        return appendStr;
    };
    SearchResultMain.prototype.bindProductCardEvents = function (wrapper) {
        wrapper.querySelectorAll('.product-item').forEach(function (item) {
            item.addEventListener('click', function (e) {
                var target = e.target;
                if (target.closest('.daetool-secondary-download-outer-btn')) {
                    return;
                }
                var learnMoreUrl = item.getAttribute('data-learnmore');
                if (learnMoreUrl) {
                    window.open(learnMoreUrl);
                }
            });
        });
    };
    SearchResultMain.prototype.createAppQrcode = function () {
        var appCodeListDom = Tool.$_selectAll(this.resultDom, '.qr-code-img');
        appCodeListDom.forEach(function (item) {
            var downloadUrl = item.getAttribute('data-dUrl') || item.getAttribute('data-url');
            if (downloadUrl && typeof createQrcode === 'function') {
                item.innerHTML = '';
                createQrcode(item, downloadUrl);
            }
        });
    };
    return SearchResultMain;
}());
export default SearchResultMain;
